import memberRouters from './member/routers'
import consumingRecordsRouters from './member-consuming-records/routers'
import memberCouponRouters from './member-coupon/routers'
import cancelCouponRouters from './cancel-coupon/routers'
import goOutManagementRouters from './go-out-management/routers'
import pointsMallRouters from './points-mall/routers'

export default [
  ...memberRouters,
  ...consumingRecordsRouters,
  ...memberCouponRouters,
  ...cancelCouponRouters,
  ...goOutManagementRouters,
  ...pointsMallRouters
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/routers.js